import { createElement, useContext } from 'react';
import { ProTableCompactButton } from '@/components/table/pro-table/components/pro-table-compact-button';
import { ProTableZebraButton } from '@/components/table/pro-table/components/pro-table-zebra-button';
import { ProTableCrossLineButton } from '@/components/table/pro-table/components/pro-table-cross-line-button';
import { ToggleIconGroup } from '@/components/table/pro-table/components/toggle-icon';
import { Button } from '@alifd/next';
import { ProTableSettingContext } from '@/components/table/pro-table/contexts/pro-table-setting-context';
import './index.scss';
const Operations = ({ settingButtons, actionBarButtons, isDesign, editable, openPane, }) => {
    const { setEditType, refreshList } = useContext(ProTableSettingContext);
    const isText = actionBarButtons?.text;
    const craete = () => {
        setEditType('create');
        openPane(['1', '2']);
    };
    const AddButton = () => (createElement(Button, { type: "primary", text: isText, disabled: isDesign, onClick: craete, size: "small" }, "\u65B0\u589E"));
    const RefreshButton = () => (createElement(Button, { text: isText, disabled: isDesign, onClick: () => refreshList(), size: "small" }, "\u5237\u65B0"));
    return (createElement("div", { className: "top-actions-group" },
        createElement("div", { className: "left-group" }, isText ? (createElement("div", { style: {
                display: 'flex',
                columnGap: 4,
            } },
            editable && createElement(AddButton, null),
            actionBarButtons?.dataSource?.map(({ title, type, disabled, hidden, key, onClick }) => {
                return (!hidden && (createElement(Button, { type: type, disabled: isDesign || disabled, text: true, key: key, onClick: onClick, size: "small" }, title)));
            }),
            createElement(RefreshButton, null))) : (createElement(Button.Group, { size: "small" },
            editable && createElement(AddButton, null),
            actionBarButtons?.dataSource?.map(({ title, type, disabled, hidden, key, onClick }) => {
                return (!hidden && (createElement(Button, { type: type, disabled: isDesign || disabled, key: key, onClick: onClick }, title)));
            }),
            createElement(RefreshButton, null)))),
        createElement("div", { className: "right-group" }, settingButtons && (createElement(ToggleIconGroup, null,
            createElement(ProTableCompactButton, null),
            createElement(ProTableZebraButton, null),
            createElement(ProTableCrossLineButton, null))))));
};
export default Operations;
